import React from 'react';
import ThisProject from '../ThisProject';
import { Gallery, ImageMedia, Section, TextBox } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent h-fit'>
          <div className='relative flex center w-full'>
            <ImageMedia src={require("./assets/LES-PARFUMS-D'IGOR_004.jpg")} />
          </div>
          <Section padded className={"space-y-8"}>
            <TextBox resp title="Processus de modélisation" descr={"Afin de réaliser une représentation fidèle du produit, nous collectons tous les éléments de branding et informations de fabrication. "} />
            <ImageMedia src={require("./assets/LES-PARFUMS-D'IGOR_002.jpg")} />
          </Section>
          <Section className={"resp"}>
            <Gallery /* vertical */ content={[
              { type: 'image', src: require("./assets/LES-PARFUMS-D'IGOR_003.jpg") },
              { type: 'image', src: require("./assets/LES-PARFUMS-D'IGOR_004.jpg") },
              { type: 'image', src: require("./assets/LES-PARFUMS-D'IGOR_005.jpg") },
              { type: 'image', src: require("./assets/LES-PARFUMS-D'IGOR_007.jpg") },
              { type: 'video', src: require("./assets/LesParfumsDIgor_R01.mp4"), muted:true },
              { type: 'image', src: require("./assets/LES-PARFUMS-D'IGOR_007_b.jpg") },
            ]}>
            </Gallery>
          </Section>

          <ImageMedia src={require("./assets/LES-PARFUMS-D'IGOR_006.jpg")} />

        </div>
      )}
    </ThisProject>
  )
}



export default Content